import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box';
import personlStyle from "./PersonalForm.module.css"
import { Button, TextField, Typography } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import axios from 'axios';


const PersonalForm = () => {

    const [checkuserData, setCheckUserData] = useState([]);

    const getData = async () => {

        try {
            const res = await axios.get(`${process.env.REACT_APP_STEELADMIN}/form/GetAllUserFormCheck`).then((res) => {

                setCheckUserData(res.data.map(((data) => {

                    let per = JSON.parse(data.permission);

                    return {
                        ...data,
                        permission: per
                    }
                })));

            })
        } catch (error) {
            console.log(error)
        }
    }


    useEffect(() => {
        getData();
    }, [])

    const handleCheckBox = (id, permissionId) => {
        console.log(id, "dsadsa", permissionId)
        setCheckUserData((prev) => {
            const updatedData = prev.map((dd) => {
                if (dd.id === id) {
                    return {
                        ...dd,
                        permission: {
                            ...dd.permission,
                            [permissionId]: !dd.permission[permissionId],
                        },
                    };
                }
                return dd;
            });

            return updatedData;
        });

       
    }

   
    const handelSubmit = () => {


        
        const convertedData = checkuserData.map((item) => {

            if (typeof item.permission === "object" && !Array.isArray(item.permission)) {

                item.permission = Object.values(item.permission);
            }
            return item;
        });

        
        try {


            const res = axios.post(`${process.env.REACT_APP_STEELADMIN}/form/setUserForm`, convertedData).then((res) => {
                setCheckUserData(res.data.map(((data) => {

                    let per = JSON.parse(data.permission);

                    return {
                        ...data,
                        permission: per
                    }
                })));
            })
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <div className={personlStyle.Main}>
            <Box className={personlStyle.Start}>
                <Typography variant='h2'>Personal Details</Typography>
                <form action="">
                {checkuserData.map((data) => {
                            return (
                    <Box className={personlStyle.Rolecheck} key={data.id}>
                        <label>{data.name} </label>
                        <FormGroup className={personlStyle.RolesCheckGroup} >
                            <FormControlLabel
                                control={<Checkbox checked={data.permission[1]} onChange={() => handleCheckBox(data.id, 1)} />}
                                label={<Typography className={personlStyle.newOne}>Mandatory field</Typography>} />
                            <FormControlLabel
                                control={<Checkbox checked={data.permission[0]} onChange={() => handleCheckBox(data.id, 0)}/>}
                                label={<Typography className={personlStyle.newOne}>display on website</Typography>} />
                        </FormGroup>
                    </Box>
                            )
                })}
                  
                    <Box className={personlStyle.RoleButton}>
                        <Button onClick={handelSubmit} variant='contained' className={personlStyle.saveButton}>Save changes</Button>
                    </Box>
                </form>

            </Box>
        </div>
    )
}

export default PersonalForm
